module.exports = __webpack_public_path__ + "static/media/sorting.e77c6f90.svg";